module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-double-left-30d8007916616e1ef1b531ff97aa0226.svg";